import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'
import { formatDate } from '../../Utils/Common';

const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const MiscInfo = ({miscData, fetchMembersData, isLoading, id}) => {
    const [misInfoForm] = Form.useForm();
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [miscInfoData, setMiscInfoData] = useState([])

    const handleDelete = (key) => {
        const newData = [...miscInfoData];
        newData.splice(key, 1); 
        setMiscInfoData(() => newData)
    };
    const addRow = () => {
        const newData = [...miscInfoData];
        newData.push({
            club_names: '',
            names: '',
            date_range: undefined,
            isWritable: true,
        });
        setMiscInfoData(newData);
    };

    const handleTable = (e, index, name, isRange) => {
        if(isRange){
            setMiscInfoData(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    from: e ? dayjs(e[0], 'YYYY/MM/DD') : undefined,
                    to: e ? dayjs(e[1], 'YYYY/MM/DD') : undefined,
                    date_range: [
                        e ? dayjs(e[0], 'YYYY/MM/DD') : undefined,
                        e ? dayjs(e[1], 'YYYY/MM/DD') : undefined,
                    ]
                };
                return newState;
            });
        } else {
            const { value } = e.target
            setMiscInfoData(prevState => {
              const newState = [...prevState];
              newState[index] = { 
                ...newState[index],
                [name]: value
              };
              return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = miscInfoData?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setMiscInfoData(newData);
    };

    const defaultColumns = [
        {
            title: 'Club Name',
            dataIndex: 'club_names',
            align: 'center',
            key: 'club_names',
            render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.club_names}
                    onChange={(e) => handleTable(e, index, "club_names")}
                />
            ) : record.club_names
          ),
        },
        {
            title: 'Name',
            dataIndex: 'names',
            align: 'center',
            key: 'names',
            render: (_, record, index) => (
            record.isWritable ? (
               
                <Input
                    value={record.names}
                    onChange={(e) => handleTable(e, index, "names")}
                />
            ) : record.names
          ),
        },
        {
            title: 'From - To',
            dataIndex: 'data_range',
            align: 'center',
            key: 'data_range',
            render: (_, record, index) => (
            record.isWritable ? (
                <RangePicker   
                    style={{width:'100%'}}
                    placeholder={['Date From', 'Date To']}
                    format={'YYYY/MM/DD'}
                    value={ 
                        [
                            record?.from ? dayjs(record?.from, 'YYYY/MM/DD') : undefined,
                            record?.to ? dayjs(record?.to, 'YYYY/MM/DD') : undefined
                        ]

                    }
                    onChange={(e) => handleTable(e, index, "data_range", true)}
                />
            ) : formatDate(record?.from) + " - " + formatDate(record?.to)
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            width: '10%',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
            onClick: (e) => {
                e.stopPropagation();
            },
            }),
        },
    ];
    const handleCreateAddress = () => {
        misInfoForm.validateFields().then(values => {
            const newValues = {
                member_id: id,
                educational_attainment: values.educational_attainment,
                business_info: values.business_info,
            }

            newValues.club_ids =  miscInfoData?.map((item)=>item.club_ids || "")
            newValues.club_names =  miscInfoData?.map((item)=>item.club_names || "")
            newValues.names =  miscInfoData?.map((item)=>item.names || "")
            newValues.froms =  miscInfoData?.map((item)=>item.date_range ? item.date_range[0]?.format("YYYY-MM-DD") : "")
            newValues.tos =  miscInfoData?.map((item)=>item.date_range ? item.date_range[1]?.format("YYYY-MM-DD") : "")

            callPost(
                "members/update_misc_info", 
                newValues,
                false,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed ', errorInfo);
        });
    };

    const validateArray = (array) => {
        return array.every((item) => {
          return item.club_names !== "" || item.names !== "" || item.date_range !== undefined;
        });
    };
    
    useEffect(() => {
        if(miscData){
            misInfoForm.setFieldsValue({
                educational_attainment: miscData[0]?.educational_attainment,
                business_info: miscData[0]?.business_info,
            });

            const misc_data = miscData[0]?.misc_info_items?.map((data) => ({
                id: data.id,
                member_misc_info_id: data.member_misc_info_id,
                club_id: data.club_id,
                club_names: data.club_name,
                names: data.name,
                from: data.from,
                to: data.to,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
                date_range: [
                    data.from ? dayjs(data.from, 'YYYY/MM/DD') : undefined,
                    data.to ? dayjs(data.to, 'YYYY/MM/DD') : undefined
                ],
            }))

            setMiscInfoData(misc_data || [])
        }
    }, [miscData, misInfoForm])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                    form={misInfoForm}

                >
                    {/* <Divider className='divider-text'>MAILING LABEL</Divider> */}
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Employment / Business Info"
                                name="business_info"
                                className='p-0 m-0'
                            >
                                <TextArea rows={4}/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width mb-4'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Educational Attainment"
                                name="educational_attainment"
                                className='p-0 m-0'
                            >
                                <TextArea rows={4}/>
                            </Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={miscInfoData}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAddress}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(miscInfoData)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default MiscInfo
